var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bar",style:({ '--color': _vm.color, '--bgColor': _vm.bgColor, '--fillColor': _vm.fillColor, '--fillAmount': _vm.value < 100 ? _vm.value : 100.5 })},[_vm._v(_vm._s(_vm.value)+"%")])
}
var staticRenderFns = []

export { render, staticRenderFns }